namespace Core {
    function AgentCorrelationId(
        agentModeService: any,
        tripService: TripService,
        $q: ng.IQService,
        $routeParams: ng.route.IRouteParamsService
    ) {
        return {
            scope: {},
            replace: true,
            template: `<div class="supplier-name" ng-show="::cm.hotelAvailabilitySearchId">
                         Search Id: {{::cm.hotelAvailabilitySearchId}}
                       </div>`,
            controllerAs: 'cm',
            controller: function() {
                agentModeService.getDebugSettings()
                    .then(debugSettings => _.get(debugSettings, 'EnableSearchTracing'))
                    .then(enableSearchTracing => enableSearchTracing && tripService.getTrip($routeParams.tripId))
                    .then(trip => _.get(trip, 'HotelsRequest.AvailabilitySearchId'))
                    .then(availabilitySearchId => this.hotelAvailabilitySearchId = availabilitySearchId);
            },
        };
    }

    if (TRPCONFIG.Domain.isAgentMode) {
        angular
            .module('core')
            .directive('agentCorrelationId', AgentCorrelationId);
    }
}
